"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * eXtend Media Paywall Service API
 * Media Wall API Specification
 *
 * The version of the OpenAPI document: v1
 * Contact: t.ioannidis@extend.gr
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

/**
 * The CommandUpdateAdScoreSlide model module.
 * @module model/CommandUpdateAdScoreSlide
 * @version 1.1.3-alpha.1
 */
class CommandUpdateAdScoreSlide {
  /**
   * Constructs a new <code>CommandUpdateAdScoreSlide</code>.
   * @alias module:model/CommandUpdateAdScoreSlide
   */
  constructor() {
    CommandUpdateAdScoreSlide.initialize(this);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  static initialize(obj) {}

  /**
   * Constructs a <code>CommandUpdateAdScoreSlide</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/CommandUpdateAdScoreSlide} obj Optional instance to populate.
   * @return {module:model/CommandUpdateAdScoreSlide} The populated <code>CommandUpdateAdScoreSlide</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new CommandUpdateAdScoreSlide();
      if (data.hasOwnProperty('id')) {
        obj['id'] = _ApiClient.default.convertToType(data['id'], 'String');
      }
      if (data.hasOwnProperty('slide_number')) {
        obj['slide_number'] = _ApiClient.default.convertToType(data['slide_number'], 'Number');
      }
      if (data.hasOwnProperty('content_id')) {
        obj['content_id'] = _ApiClient.default.convertToType(data['content_id'], 'String');
      }
    }
    return obj;
  }

  /**
   * Validates the JSON data with respect to <code>CommandUpdateAdScoreSlide</code>.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @return {boolean} to indicate whether the JSON data is valid with respect to <code>CommandUpdateAdScoreSlide</code>.
   */
  static validateJSON(data) {
    // ensure the json data is a string
    if (data['id'] && !(typeof data['id'] === 'string' || data['id'] instanceof String)) {
      throw new Error("Expected the field `id` to be a primitive type in the JSON string but got " + data['id']);
    }
    // ensure the json data is a string
    if (data['content_id'] && !(typeof data['content_id'] === 'string' || data['content_id'] instanceof String)) {
      throw new Error("Expected the field `content_id` to be a primitive type in the JSON string but got " + data['content_id']);
    }
    return true;
  }
}

/**
 * @member {String} id
 */
CommandUpdateAdScoreSlide.prototype['id'] = undefined;

/**
 * @member {Number} slide_number
 */
CommandUpdateAdScoreSlide.prototype['slide_number'] = undefined;

/**
 * @member {String} content_id
 */
CommandUpdateAdScoreSlide.prototype['content_id'] = undefined;
var _default = exports.default = CommandUpdateAdScoreSlide;